<template>
  <div class="container-fluid" style="height: 100vh">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="manageshipmentdet" v-if="!isShipmentCompleted">
          <div
            class="container-fluid p-0 d-flex flex-column"
            style="height: 100%;"
          >
            <HeaderBox @containerNumber="getContainerNumber"></HeaderBox>
            <div class="col-md p-0 manageshipmentdet__mastercontent">
              <div class="row m-0" style="height: 100%">
                <div
                  class="col-md-4 p-0 manageshipmentdet__mastercontent--left"
                >
                  <Directchat></Directchat>
                </div>
                <div
                  class="col-md pl-1 pr-0 manageshipmentdet__mastercontent--right"
                >
                  <div class="row m-0 manageshipment__topcontent">
                    <button
                      v-for="tab in tabs"
                      :key="tab.id"
                      class="col-md p-0 mastercontent__tabs"
                      :class="[
                        {
                          'mastercontent__tabs--selected':
                            selectedtabs === tab.content
                        },
                        detail &&
                        detail.freightMode === 'AIR' &&
                        selectedtabs === tab.content
                          ? 'global__bc_purple'
                          : detail &&
                            detail.freightMode === 'OCEAN' &&
                            selectedtabs === tab.content
                          ? 'global__bc_blue'
                          : detail &&
                            detail.freightMode === 'LAND' &&
                            selectedtabs === tab.content
                          ? 'global__bc_deepgreen'
                          : ''
                      ]"
                      @click="selectedtabs = tab.content"
                    >
                      <p>{{ tab.title }}</p>
                    </button>
                  </div>
                  <div class="manageshipment__content">
                    <keep-alive>
                      <component
                        v-bind:is="currentStepComponent"
                        :containerNumber="containerNumber"
                      ></component>
                    </keep-alive>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end class = managementshipmentDetail -->
        <div class="_verification_page" v-else>
          <div class="col-sm p-0">
            <div
              class="row m-0 afterverify_page align-items-center justify-content-center"
            >
              <div class="text-center">
                <img
                  class="completed_img"
                  src="@/assets/image/icon/complete.svg"
                  alt=""
                />
                <h2 class="my-2">Shipment Complete</h2>
                <p class="p-0">
                  Congratulation! your shipment has been completed. As an
                  invited user, you can no longer use this Andalin feature. If
                  you wish to ship with Andalin, please register as customer.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue';
import HeaderBox from '@/components/managementShipment/detail/HeaderBox';
import ShipmentTracking from '@/components/managementShipment/detail/ShipmentTracking';
import Details from '@/components/managementShipment/detail/Details';
import Documents from '@/components/managementShipment/detail/Documents';
import MsHistory from '@/components/managementShipment/detail/MsHistory';
import Directchat from '@/components/managementShipment/detail/DirectChat';
import FreightTracking from '../../components/managementShipment/detail/FreightTracking.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'managementshipment',
  components: {
    Sidebar,
    HeaderBox,
    ShipmentTracking,
    Details,
    Documents,
    MsHistory,
    Directchat,
    FreightTracking
  },
  data() {
    return {
      isShipmentCompleted: false,
      selectedtabs: ShipmentTracking,
      selectedtab: 1,
      managetype_detail: 'Ongoing',
      containerNumber: '',
      tabs: [
        {
          id: 1,
          title: 'STATUS',
          content: ShipmentTracking
        },
        {
          id: 2,
          title: 'DETAILS',
          content: Details
        },
        {
          id: 3,
          title: 'DOCUMENTS',
          content: Documents
        },
        {
          id: 4,
          title: 'HISTORY',
          content: MsHistory
        },
        {
          id: 5,
          title: 'TRACKING',
          content: FreightTracking
        }
      ]
    };
  },
  mounted() {
    this.fetchShipmentDetail();
  },
  computed: {
    currentStepComponent: function() {
      const _this = this;
      if (this.selectedtabs === ShipmentTracking) {
        _this.selectedtab = 1;
      }
      if (this.selectedtabs === Details) {
        _this.selectedtab = 2;
      }
      if (this.selectedtabs === Documents) {
        _this.selectedtab = 3;
      }
      if (this.selectedtabs === MsHistory) {
        _this.selectedtab = 4;
      }
      if (this.selectedtabs === FreightTracking) {
        _this.selectedtab = 5;
      }
      return this.selectedtabs;
    },
    ...mapGetters({
      detail: 'shipment/item',
      isLoading: 'shipment/isLoading',
      isError: 'shipment/error',
      otif: 'shipment/otif',
      isLoadingOtif: 'shipment/isLoadingOtif',
      isErrorOtif: 'shipment/errorOtif',
      profile: 'auth/profile'
    })
  },
  methods: {
    getContainerNumber(data) {
      this.containerNumber = data;
    },
    async fetchShipmentDetail() {
      const shipmentId = this.$route.params.id_shipment;
      const orderNumber = this.$route.params.order_number;
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_DETAIL', {
        shipmentId,
        orderNumber
      });
    },
    async fetchShipmentOtif() {
      await this.$store.dispatch('shipment/FETCH_OTIF_DETAIL', {
        shipmentId: this.$route.params.id_shipment,
        orderNumber: this.$route.params.order_numbe
      });
    },
    pushdata() {
      this.tabs = [];
      this.tabs.push(
        {
          id: 1,
          title: 'STATUS',
          content: ShipmentTracking
        },
        {
          id: 2,
          title: 'DETAILS',
          content: Details
        },
        {
          id: 3,
          title: 'DOCUMENTS',
          content: Documents
        },
        {
          id: 4,
          title: 'HISTORY',
          content: MsHistory
        },
        {
          id: 5,
          title: 'TRACKING',
          content: FreightTracking
        }
      );
    }
  },
  watch: {
    otif(data) {
      this.pushdata();
      if (this.detail) {
        if (this.detail.freightType.includes('AIR')) {
          if (
            this.detail.orderStat !== 'PICKUP' &&
            this.detail.orderStat !== 'DESTINATION_LOCAL_HANDLING'
          ) {
            this.tabs.splice(4);
          } else if (data && data.length > 0) {
            // eslint-disable-next-line array-callback-return
            data.filter(item => {
              if (item.otif_stat === 'PICKUP' && !item.tracking_link) {
                this.tabs.splice(4);
              } else if (
                item.otif_stat === 'DESTINATION_LOCAL_HANDLING' &&
                !item.tracking_link
              ) {
                this.tabs.splice(4);
              }
            });
          } else {
            this.tabs.splice(4);
          }
        }
        console.log('muncul');
      }
    },
    isLoading(data) {
      if (
        !data &&
        _.isNil(this.detail) &&
        this.profile.codeUserType === 'GUEST'
      ) {
        this.isShipmentCompleted = true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/managementShipmentDetail/index.vue